export const formatCurrencyJP = (amount: number, affix = true, minimumFractionDigits = 0): string => {
  if (!amount && amount !== 0)
    return ''

  const priceFormatter = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
    minimumFractionDigits: minimumFractionDigits
  })

  return priceFormatter.format(amount).replace(/￥/, '').concat(affix ? '円' : '')
}
